import { useQuery } from '@tanstack/react-query';
import { MatchMbmSnapshot } from '../../turboLive/dto/SnapshotEnvelope';
import { nuiCtx } from '../../../common/initialization';
import { clearMbm } from '../../turboLive/push/overview/handlers/matchHandlers';
import { matchDetailMbmSnapshot } from '../../turboLive/push/detail/handlers';
import { dispatchSync } from 'nike-re-framejs';

// MBM for results
export const useMbmForMatch = (matchId: string, enabled: boolean) => {
    const { isLoading, isError, error, data } = useQuery<MatchMbmSnapshot, Error>(
        ['mbmMatch', matchId],
        () => nuiCtx.services.nikeone.get<never, MatchMbmSnapshot>('/v1/mbm/match/' + matchId),
        {
            onSuccess: (resp: MatchMbmSnapshot) => {
                dispatchSync(clearMbm);
                dispatchSync(matchDetailMbmSnapshot(resp));
            },
            onError: error => console.error('Error when fetching MBM', error),
            enabled: enabled && !!matchId
        }
    );

    return { isLoading, isError, error, data };
};
